import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/mainPage";
import LoginPage from "../pages/loginPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
]);

export default router;
